import { MoreHorizontal, TrendingUp } from "lucide-react";
import { Sparkline } from "@/components/Sparkline";
import { cn } from "@/lib/utils";

/* ---------------------------------------------------------------------------
   KpiCard — tarjeta de indicador con tinte de superficie + sparkline.
   Patrón "Cards, KPIs & Data" del Design System. Usado en Dashboard y en la
   página del Design System.
--------------------------------------------------------------------------- */

interface KpiCardProps {
  label: string;
  value: string;
  delta?: string;
  /** Clase de fondo del tinte de superficie, ej. "bg-primary/10". */
  tint: string;
  /** Color del sparkline y del delta (hex). */
  color: string;
  /** Path del sparkline en viewBox 0 0 200 46. */
  spark: string;
  className?: string;
}

export function KpiCard({
  label,
  value,
  delta,
  tint,
  color,
  spark,
  className,
}: KpiCardProps) {
  return (
    <div className={cn("rounded-[1.25rem] p-5", tint, className)}>
      <div className="flex items-start justify-between">
        <span className="text-sm font-semibold text-muted-foreground">{label}</span>
        <MoreHorizontal className="h-4 w-4 text-muted-foreground" />
      </div>
      <Sparkline d={spark} color={color} />
      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-extrabold tracking-tight">{value}</span>
        {delta && (
          <span
            className="flex items-center gap-0.5 text-xs font-bold"
            style={{ color }}
          >
            <TrendingUp className="h-3 w-3" />
            {delta}
          </span>
        )}
      </div>
    </div>
  );
}
